import script from "./ManageIterationBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageIterationBox.vue?vue&type=script&setup=true&lang=js"

import "./ManageIterationBox.vue?vue&type=style&index=0&id=5c2c1788&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2c1788"]])

export default __exports__